function getLocale() {
  const locale = process.env.VUE_APP_LOCALITY;

  switch (locale) {
    case "de_de":
      return "de";
    case "de_en":
      return "en";
  }
}

export default getLocale;
